import i18n from "@/i18n/i18n";
import { onboardingContext } from "@/init/onboarding/onboardingContext";

const TABLE = "[data-testid='eg-selectable-table']";

const BADGE_PRIORITY = ["ready", "queued", "failed", "reviewed", "exported"];

const findStatusStep = () => {
  for (const statusClass of BADGE_PRIORITY) {
    if (document.querySelector(`${TABLE} .status-badge.${statusClass}`)) {
      return {
        element: `${TABLE} .status-badge.${statusClass}`,
        popover: {
          title: i18n.t(
            `onboarding.assignmentView.statusSteps.${statusClass}.title`
          ),
          description: i18n.t(
            `onboarding.assignmentView.statusSteps.${statusClass}.description`
          ),
          side: "left",
          align: "center",
        },
      };
    }
  }
  return null;
};

const getWorkspaceStep = (router) => {
  const workspaceKey =
    router?.currentRoute?.params?.workspaceKey || "essaygrader";
  const isLms = ["google", "canvas"].includes(workspaceKey);
  const i18nKey = isLms ? workspaceKey : "essaygrader";
  const specificSelector = `[data-testid='workspace-wrapper-${i18nKey}']`;

  const resolveElement = () => {
    if (isLms) {
      return document.querySelector(specificSelector)
        ? specificSelector
        : "[data-testid='workspaces-wrapper']";
    }
    const essaygraderEl = onboardingContext.workspaceEssaygrader;
    const wrapperEl = onboardingContext.workspacesWrapper;
    const fitsInView =
      essaygraderEl &&
      wrapperEl &&
      essaygraderEl.scrollHeight <= wrapperEl.clientHeight;
    return fitsInView ? specificSelector : "[data-testid='workspaces-wrapper']";
  };

  return {
    element: resolveElement(),
    onHighlightStarted: () => {
      if (isLms) {
        document.querySelector(specificSelector)?.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      } else {
        onboardingContext.workspacesWrapper?.scrollTo({ top: 0 });
      }
    },
    popover: {
      title: i18n.t(`onboarding.assignmentView.workspaceTree.${i18nKey}.title`),
      description: i18n.t(
        `onboarding.assignmentView.workspaceTree.${i18nKey}.description`
      ),
      side: "right",
      align: "start",
    },
  };
};

export default (router) => ({
  get steps() {
    return [
      {
        element: "[data-testid='grade-more-submissions-button']",
        markKeys: ["gradeMoreSubmissionsHint"],
        popover: {
          title: i18n.t("onboarding.assignmentView.step2.title"),
          description: i18n.t("onboarding.assignmentView.step2.description"),
          side: "left",
          align: "start",
          onNextClick: (element, step, options) => {
            const statusStep = findStatusStep();
            if (!statusStep) {
              const hasAnyBadge = document.querySelector(
                `${TABLE} .status-badge`
              );
              if (!hasAnyBadge) {
                options.driver.destroy();
                return;
              }
              options.driver.moveNext();
              return;
            }
            const config = options.driver.getConfig();
            const placeholderIndex = config.steps.findIndex(
              (configStep) => configStep.element === `${TABLE} .status-badge`
            );
            if (placeholderIndex !== -1) {
              config.steps[placeholderIndex] = statusStep;
            } else {
              config.steps.push(statusStep);
            }
            options.driver.setConfig(config);
            options.driver.moveNext();
          },
        },
      },

      getWorkspaceStep(router),

      {
        element: `${TABLE} .status-badge`,
        popover: {
          title: i18n.t("onboarding.assignmentView.step3.title"),
          description: i18n.t("onboarding.assignmentView.step3.description"),
          side: "left",
          align: "center",
        },
      },
    ];
  },
});
